const wrapper = "_araw1s3mxu9";

export { wrapper };
import "./atom.footer.style.linaria.module.css";
//# sourceMappingURL=atom.footer.style.js.map
